import { Route, Routes } from 'react-router-dom';
import Login from '../pages/login/LoginPage';
import PlayerListPage from '../pages/player/player-list/PlayerListPage';
import { GuestOnly } from './guards/GuestOnly';
import { ProtectedRoute } from './guards/ProtectedRoute';
import { AuthProvider } from '@/context/AuthContext';
import CommonLayout from '@/components/layout/CommonLayout';
import CenterListPage from '@/pages/partner/center-list/CenterListPage';
import PlannerListPage from '@/pages/partner/planner-list/PlannerListPage';
import LicenseKeyManagementPage from '@/pages/license/license-list/LicenseKeyManagementPage';
import PlayerSignUpPage from '@/pages/sign-up/player/PlayerSignUpPage';
import CenterSignUpPage from '@/pages/sign-up/center/CenterSignUpPage';

const AppRouter = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/*"
          element={
            <GuestOnly>
              <Login />
            </GuestOnly>
          }
        />
        <Route element={<ProtectedRoute />}>
          <Route element={<CommonLayout />}>
            <Route path="/player-list/:page?" element={<PlayerListPage />} />
            <Route
              path="/partner/center-list/:page?"
              element={<CenterListPage />}
            />
            <Route
              path="/partner/planner-list/:page?"
              element={<PlannerListPage />}
            />
            <Route path="/sign-up/player" element={<PlayerSignUpPage />} />
            <Route path="/sign-up/center" element={<CenterSignUpPage />} />
            <Route
              path="/license-management/:page?"
              element={<LicenseKeyManagementPage />}
            />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
};

export default AppRouter;
